console.log("Klaviyo custom JS loaded");

function waitForKlaviyo(callback) {
  if (typeof window.klaviyo !== "undefined") {
    callback();
  } else {
    setTimeout(function () {
      waitForKlaviyo(callback);
    }, 300);
  }
}

function identifyKlaviyoUser() {
  if (window.shopifyCustomerEmail) {
    klaviyo.identify({
      email: window.shopifyCustomerEmail
    });
    console.log("Klaviyo identified from Shopify:", window.shopifyCustomerEmail);
  } else {
    console.log("No Shopify customer email found. Using Klaviyo's own recognition if available.");
  }
}

document.addEventListener('DOMContentLoaded', function () {
  waitForKlaviyo(function () {
    identifyKlaviyoUser();

    const productDataEl = document.querySelector('[data-klaviyo-product]');
    if (!productDataEl) {
      console.log('No product data element found');
      return;
    }

    const product = JSON.parse(productDataEl.textContent);
    console.log('Klaviyo Viewed Product fired', product);

    klaviyo.track('Viewed Product', {
      ProductID: product.id,
      ProductName: product.name,
      Price: product.price,
      ImageURL: product.image,
      URL: product.url
    });
  });
});

document.addEventListener('click', function (e) {
  console.log('Clicked element:', e.target);

  const btn = e.target.closest(
    '[name="add"], [type="submit"], .product-form__submit, .add-to-cart, [data-add-to-cart], button'
  );

  if (!btn) return;

  console.log('Possible add to cart button found:', btn);

  waitForKlaviyo(function () {
    identifyKlaviyoUser();

    const productDataEl = document.querySelector('[data-klaviyo-product]');
    if (!productDataEl) {
      console.log('No product data element found on click');
      return;
    }

    const product = JSON.parse(productDataEl.textContent);
    console.log('Klaviyo Added to Cart fired', product);

    setTimeout(function () {
      klaviyo.track('Added to Cart', {
        AddedItemProductID: product.id,
        AddedItemProductName: product.name,
        AddedItemPrice: product.price,
        AddedItemImageURL: product.image,
        AddedItemURL: product.url
      });
    }, 800);
  });
});